import React from "react";
import withStyles from '@mui/styles/withStyles';
import NotificationBar from "../shared/notification-bar";
import { createStyles } from "@mui/styles";
import { Viewer } from '@react-pdf-viewer/core';
import { Worker, SpecialZoomLevel } from '@react-pdf-viewer/core';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

// const styles = (theme) => createStyles({
//   root: {
//     backgroundColor: "#fff",
//   },
//   appBar: {
//     position: "relative",
//   },
//   title: {
//     marginLeft: theme.spacing(2),
//     flex: 1,
//   },
//   toolbar: {
//     backgroundColor: "#fff",
//   },
//   custom: {
//     padding: theme.spacing(2),
//     paddingBottom: theme.spacing(8),
//   },
//   iframeholder: {
//     width: "100vw",
//     height: "100vh",
//     "-webkit-overflow-scrolling": "touch",
//     overflowY: "scroll",
//   },
//   iframe: {
//     width: 1,
//     minWidth: "100%",
//     height: "100vh",
//     border: 0,
//   },
//   iframeBar: {
//     position: "absolute",
//     height: 60,
//     width: "100%",
//     backgroundColor: "#1AB2B3",
//     color: "#fff",
//     paddingLeft: 20,
//   },
// });

const PlayLection = ({ iFrameUrl, errorMessage, successMessage, popup }) => {
  const iframestyle = popup ? {  width: "calc(100vw - 84px)", height: "65vh", border: 0, overflow: "auto" } : { width: "100vw", height: "100vh", border: 0 }
  return (
    <>
      {(errorMessage || successMessage) && (
        <NotificationBar
          successMessage={successMessage}
          errorMessage={errorMessage}
        />
      )}
      <div style={{ backgroundColor: "#ffff" }}>
        <iframe
          allowTransparency={true}
          style={iframestyle}
          src={iFrameUrl}
          title="Lektion"
        ></iframe>
      </div>
    </>
  );
};

export default PlayLection;
